import dayjs from 'dayjs'

export enum ChartType {
  GPUCore = 1,
  GPURAM = 2,
  CPU = 3,
  Memory = 4,
  Disk = 5,
  Bandwidth = 6,
}

// Private Region Host Metrics
export enum HostChartType {
  UptimeRate = 8,
  CpuUtilization = 9,
  MemoryUtilization = 10,
  DiskUtilization = 11,
  DiskIOReadBytesPerSec = 12,
  DiskIOWriteBytesPerSec = 13,
  NetworkReceiveBytesPerSec = 14,
  NetworkTransmitBytesPerSec = 15,
  NvidiaGpuCount = 16,
  NvidiaDriverVersion = 17,
  NvidiaGpuUtilization = 18,
  NvidiaGpuRamUtilization = 19,
}

export function enumToChartType(num: number): ChartType {
  switch (num) {
    case 1:
      return ChartType.GPUCore
    case 2:
      return ChartType.GPURAM
    case 3:
      return ChartType.CPU
    case 4:
      return ChartType.Memory
    case 5:
      return ChartType.Disk
    case 6:
      return ChartType.Bandwidth
    default:
      throw new Error(`Invalid chart type: ${num}`)
  }
}

export function enumToHostChartType(num: number): HostChartType {
  switch (num) {
    case 8:
      return HostChartType.UptimeRate
    case 9:
      return HostChartType.CpuUtilization
    case 10:
      return HostChartType.MemoryUtilization
    case 11:
      return HostChartType.DiskUtilization
    case 12:
      return HostChartType.DiskIOReadBytesPerSec
    case 13:
      return HostChartType.DiskIOWriteBytesPerSec
    case 14:
      return HostChartType.NetworkReceiveBytesPerSec
    case 15:
      return HostChartType.NetworkTransmitBytesPerSec
    case 16:
      return HostChartType.NvidiaGpuCount
    case 17:
      return HostChartType.NvidiaDriverVersion
    case 18:
      return HostChartType.NvidiaGpuUtilization
    case 19:
      return HostChartType.NvidiaGpuRamUtilization
    default:
      throw new Error(`Invalid host chart type: ${num}`)
  }
}

export const extractTimePoints = (items: any[]) => {
  const timestamps = new Set<number>()
  items.forEach((item) => {
    ;(item.result || []).forEach((result: any) => {
      ;(result.matrixArray || []).forEach((v: any) => {
        const timestamp = v?.matrix?.[0]
        if (Number.isFinite(timestamp)) timestamps.add(timestamp)
      })
    })
  })
  return [...timestamps].sort((a, b) => a - b).map((timestamp) => dayjs.unix(timestamp))
}
